module.exports = __webpack_public_path__ + "Images/GraphHistoric.png";


//////////////////
// WEBPACK FOOTER
// ./Images/GraphHistoric.png
// module id = 1868
// module chunks = 2